// Flow types automatically removed

import CheckMarkIcon from 'dibs-icons/exports/legacy/Checkmark';
import CloseIcon from 'dibs-icons/exports/legacy/Close';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer'; // Helpers

import { mutations } from '../utils/constants';
import styles from '../styles/errorSuccessModal.scss';

const ErrorSuccessModal = ({ description, isOpen, onClose, title, type }) => {
    const IconComponent = type === mutations.responses.ERROR ? CloseIcon : CheckMarkIcon;
    const titleEl = (
        <div>
            <div className={styles.result}>
                <IconComponent className={styles.icon} />
            </div>
            <div data-tn="response-modal-message-title" className={styles.title}>
                {title}
            </div>
        </div>
    );
    return (
        <ModalContainer
            onClose={onClose}
            isOpen={isOpen}
            modalPosition="center"
            dataTn={`share-modal-${type}`}
        >
            <ModalCloseButton onClick={onClose} />
            <BarHeader title={titleEl} />
            <ModalBody>
                <div className={styles.description}>{description}</div>
            </ModalBody>
        </ModalContainer>
    );
};

ErrorSuccessModal.defaultProps = {
    type: mutations.responses.ERROR,
};
export default ErrorSuccessModal;
